export enum SubscriptionActionListEnum {
  SET_CURRENT_SUBSCRIPTION = 'SET_CURRENT_SUBSCRIPTION',
  SET_SUBSCRIPTION_LOADING = 'SET_SUBSCRIPTION_LOADING',
  SET_SUBSCRIPTION_ERROR = 'SET_SUBSCRIPTION_ERROR',
  CLEAR_SUBSCRIPTION = 'CLEAR_SUBSCRIPTION',
}